export default __webpack_public_path__ + "static/media/glyphicons-halflings-regular.4692b9ec.ttf";